import { apiRoute, authHeader, handleResponse } from '../helpers'

export const staffSubmissionService = {
  get,
  getByIdentifiers,
  getAll,
  getCount,
  getCovid,
  getPneumonia,
  getTuberculosis,
  getGeneral,
  getGeneralForPatient,
  getForSet,
  getForPatient,
  update,
  feedback
}

function get (id, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/none/' + id, requestOptions).then(handleResponse)
}

function getForPatient (id, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/none/list/patient/' + id, requestOptions).then(handleResponse)
}

function getByIdentifiers (params, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/submissions/' + params.patient + '/' + (params.study ? params.study : null), requestOptions).then(handleResponse)
}

function getAll (filter) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/staff/submissions/' + filter, requestOptions).then(handleResponse)
}

function getCount (project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/none/count', requestOptions).then(handleResponse)
}

function getCovid (period, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/covid/list/' + period, requestOptions).then(handleResponse)
}

function getPneumonia (period, page, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/pneumonia/list/' + period + '/' + page, requestOptions).then(handleResponse)
}

function getTuberculosis (period, page, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/tb/list/' + period + '/' + page, requestOptions).then(handleResponse)
}

function getGeneral (period, page, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/none/list/' + period + '/' + page, requestOptions).then(handleResponse)
}

function getGeneralForPatient (id, project) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), Project: project }
  }

  return fetch(apiRoute() + '/api/v1/staff/none/list/patient/' + id, requestOptions).then(handleResponse)
}

function getForSet (id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/staff/none/list/image-set/' + id, requestOptions).then(handleResponse)
}

function update (id, labels, tags) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      labels: labels,
      tags: tags
    })
  }

  return fetch(apiRoute() + '/api/v1/submissions/callback/update/' + id, requestOptions).then(handleResponse)
}

function feedback (id, pathologies, other, diagnosis) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      pathologies: pathologies,
      other: other,
      diagnosis: diagnosis
    })
  }

  return fetch(apiRoute() + '/api/v1/submissions/feedback/update/' + id, requestOptions).then(handleResponse)
}
